import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import DownloadIcon from "../../../../assets/icons/DownloadIcon";
import UploadExcelModal from "../../../../components/common/UploadExcelModal";
import { EMP_API } from "../../../../constants/apiUrl";
import { APP_API } from "../../../../constants/constants";
import { useUploadGrossSalaryMutation } from "../../../../features/emp-setting/employee/employeeApi";
import useDownloadEmployeeXlsx from "../../../../hooks/useDownloadExcelWithApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";

export default function GrossSalaryModal({
  open,
  handleClose,
}: ModalComponentProps) {
  const { loading: excelLoading, downloadXlsx } = useDownloadEmployeeXlsx();
  const [uploadEmployeeData, { isLoading, isError, error, isSuccess }] =
    useUploadGrossSalaryMutation();
  useError(isError, error, "Upload gross salary fail");
  const [formData, setFormData] = useState<FormData | null>(null);

  const handleDownload = () => {
    downloadXlsx(
      APP_API + EMP_API.downloadGrossSalary,
      {},
      "employee-gross-salary",
      "formattedEmployees",
      (salary: any) => {
        return {
          "Employee Id": salary?.employee_id ?? "-",
          "Employee Name": salary?.name ?? "-",
          "Employee Email": salary?.email ?? "-",
          "Gross Salary": salary?.gross_salary ?? "-",
        };
      }
    );
  };

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Gross salary updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess]);

  return (
    <UploadExcelModal
      open={open}
      handleClose={handleClose}
      isLoading={false}
      handler={setFormData}
      title="Update Gross Salary Data in Bulk"
      warningText="First download the active Employee information's and upload it after editing desired information's."
      downloadLink={"/employee-gross-salary.xlsx"}
      footer={
        <Space size={12}>
          <Button
            className="outline-button-primary modal-button"
            icon={<DownloadIcon />}
            loading={excelLoading}
            onClick={handleDownload}
          >
            Download Existing Data
          </Button>
          <Button
            className="modal-button"
            type="primary"
            loading={isLoading}
            onClick={() => uploadEmployeeData(formData)}
          >
            Upload
          </Button>
        </Space>
      }
    />
  );
}
